import React from "react";
import { PlaylistRemove } from "@mui/icons-material";

export default function NoContent({ message }) {
  return (
    <div className="no-content">
      <PlaylistRemove className="no-content-icon" />
      <p>{message}</p>
    </div>
  );
}
